module.exports = __webpack_public_path__ + "static/media/system_flow_phone_form.212b7ebf.svg";